import React, { useContext, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Navbar,
  NavDropdown,
  Nav,
  Button,
  Offcanvas,
  Form,
} from "react-bootstrap";
import { isEmpty } from "lodash";
import { useForm } from "react-hook-form";
import io from "socket.io-client";
import AuthContext from "../context/AuthContext";
import { Helmet } from "react-helmet";import { BiSupport } from "react-icons/bi";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import helpers from "../utils/helpers";
import download from "../assets/images/download-icon.png";
import upload from "../assets/images/upload.png";
import { apiGet } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import notifySound from "../assets/newAudio.wav";
const Header = () => {
  const [socket, setSocket] = useState(null);
  const { register, handleSubmit } = useForm({ mode: "onChange" });
  const location = useLocation();
  const { count, bellSound } = useContext(AuthContext);
  const parmas = useParams();
  const navigate = useNavigate();
  const current_url = location.pathname.split("/")[1];
  let {
    user,
    logoutUser,
    user_coins,
    setUserCoins,
    getCoins,
    isRefereshLoader,
    setRefereshLoader,
  } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFormSubmit = (form_data = {}) => {
    document.documentElement.style.setProperty("--primary", "#b36c3d");
  };
  useEffect(() => {
    const newSocket = io(
      `${process.env.REACT_APP_API_BASE_URL}?token=${user._id ? user._id : 112233
      }`,
      {
        transports: ["websocket"],
      }
    );
    const coinListener = (message) => {
      setUserCoins(message.results.totalCoins);
    };
    const forceLogout = (message) => {
      const uniqueId = localStorage.getItem("uniqueId");
      if (uniqueId !== message.results.uniqueId) {
        logoutUser();
      }
    };
    newSocket.emit("getCoins", { user_id: user._id });
    newSocket.on("listenGetCoin", coinListener);
    newSocket.on("listenForceLogout", forceLogout);
    setSocket(newSocket);
    return () => newSocket.close();
  }, [setSocket]);
  const [expanded, setExpanded] = useState(false);
  const [check, setCheck] = useState(
    parmas?.id && parmas.user_type ? true : false
  );

  useEffect(() => {
    if (bellSound) {
      let interval = setInterval(() => {
        const clickSound = new Audio(notifySound);
        clickSound.play().catch(function (error) {
          console.log(
            "Chrome cannot play sound without user interaction first"
          );
        });
      }, 1500);
      return () => {
        clearInterval(interval);
      };
    }
  }, [bellSound]);
  return (
    <div>
      <header>
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=0.1, maximum-scale=3, user-scalable=yes"
          />
        </Helmet>
        <div className="top-header">
          <Container fluid>
            <Row className="align-items-center">
              <Col sm={4}>
                <div className="logo">
                  <a href="/" className="d-inline-block">
                    <img
                      src="./assets/images/logo.png"
                      alt=""
                      style={{ maxWidth: `26%` }}
                    />
                  </a>
                </div>
              </Col>
              {!isEmpty(user) ? (
                <Col sm={8}>
                  <div className="text-sm-end text-center top-header-owner">
                    <ul className="list-unstyled mb-0">
                      {(user?.userType == "sub_owner" ||
                        user?.userType == "owner") && (
                          <>
                            <li
                              onClick={() => navigate("/wallet-deposit")}
                              className="header-count cursor-pointer"
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                style={{
                                  width: "23px",
                                  height: "23px",
                                }}
                                src={download}
                              />
                              <span>{count?.depositRequests || 0}</span>
                            </li>
                            <li
                              onClick={() => navigate("/wallet-withdrawal")}
                              className="header-count cursor-pointer"
                              style={{ cursor: "pointer" }}
                            >
                              <img
                                style={{
                                  width: "23px",
                                  height: "23px",
                                }}
                                src={upload}
                              />
                              <span>{count?.withdrawalRequests || 0}</span>
                            </li>     <li
                            onClick={() => navigate("/customer-support")}
                            className="header-count cursor-pointer"
                            style={{ cursor: "pointer" }}
                          >
                           <BiSupport color="black" size={22} />
                            <span>{count?.totalUnreadCount || 0}</span>
                          </li>
                          </>
                        )}
                      <li>
                        <span>
                          {user?.userType == "sub_owner"
                            ? "WL"
                            : user?.userType == "super_admin"
                              ? "Admin"
                              : user?.userType || ""}
                        </span>{" "}
                        <strong>{user?.username || ""}</strong>
                      </li>
                      {isRefereshLoader ? (
                        <li>
                          <p className="loading-bar" id="menuRefreshLoading">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                          </p>
                        </li>
                      ) : (
                        <li>
                          <a href="#" className="text-decoration-none">
                            <span>Main</span>{" "}
                            <strong>
                              BDT {helpers.currencyFormat(user_coins)}
                            </strong>
                          </a>
                          <a
                            href="#"
                            className="btn"
                            onClick={() => getCoins()}
                          >
                            <span>
                              <i className="fas fa-redo-alt"></i>
                            </span>
                          </a>
                        </li>
                      )}

                      <li>
                        <span>GMT+6:00</span>
                      </li>
                      <li>
                        <a
                          style={{ cursor: "pointer" }}
                          as={NavLink}
                          to="#"
                          onClick={logoutUser}
                        >
                          Logout{" "}
                          <i className="fa-solid fa-right-from-bracket"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
              ) : null}
            </Row>
          </Container>
        </div>

        <div className="main-header">
          <Container fluid>
            <Navbar expand="xl" expanded={expanded}>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={() => setExpanded(expanded ? false : "expanded")}
              />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  {["agent", "sub_owner","super_agent"].includes(user?.userType) && (
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to={["sub_owner"].includes(user?.userType)?"/dashboard":"/dashboard-new"}
                      className={current_url === "dashboard" ? "active1" : ""}
                    >
                      Dashboard
                    </Nav.Link>
                  )}
                  <Nav.Link
                    as={NavLink}
                    to="/"
                    onClick={() => setExpanded(false)}
                    className={
                      current_url === "" ||
                        current_url === "account-summary" ||
                        current_url === "betting-history" ||
                        current_url === "activity-log" ||
                        current_url === "betting-profit-loss" ||
                        current_url === "transaction-history" ||
                        current_url === "transaction-history-2" ||
                        current_url === parmas?.id
                        ? "active1"
                        : ""
                    }
                  >
                    {" "}
                    Downline List
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    onClick={() => setExpanded(false)}
                    to="/my-account-summary"
                    className={
                      current_url === "my-account-summary" ||
                        current_url === "my-account-statement" ||
                        current_url === "my-profile" ||
                        current_url === "my-activity-log"
                        ? "active1"
                        : ""
                    }
                  >
                    My Account
                  </Nav.Link>
                  {user?.userType != "agent" ? (
                    <>
                      {user?.userType == "owner" ||
                        (user?.userType == "sub_owner" && (
                          <>
                            <NavDropdown
                              title="My Report"
                              id="basic-nav-dropdown"
                            >
                              {/* <NavDropdown.Item
                      onClick={() => setExpanded(false)}
                      as={NavLink}
                      to="/AprofitByDownline"
                    >
                      {" "}
                      Profit/Loss Report by Downline
                    </NavDropdown.Item> */}
                              <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/AprofitDownline"
                              >
                                {" "}
                                Profit/Loss by Downline
                              </NavDropdown.Item>   
                              <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/Adownlinesportspl"
                              >
                                Match Profit/Loss
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/AprofitMarket"
                              >
                                Profit/Loss Report by Market
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/Adownlinesportspl"
                              >
                                Profit/Loss Sports Wise
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/AprofitPlayer"
                              >
                                Profit/Loss Report By Player
                              </NavDropdown.Item>
                              {/* <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/ACdownlinesportspl"
                              >
                                All Casino Profit/Loss
                              </NavDropdown.Item> */}
                              <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/AprofitCasino"
                              >
                                Casino Profit/Loss Report by Date
                              </NavDropdown.Item>
                              {/* <NavDropdown.Item
                                onClick={() => setExpanded(false)}
                                as={NavLink}
                                to="/ACasinoprofitAndLossDownlineNew"
                              >
                                Casino P/L Downline Monthly
                              </NavDropdown.Item> */}
                            </NavDropdown>
                          </>
                        ))}

                      <Nav.Link
                        as={NavLink}
                        onClick={() => setExpanded(false)}
                        to="/Betlist"
                        className={current_url === "Betlist" ? "active1" : ""}
                      >
                        BetList
                      </Nav.Link>
                      <Nav.Link
                        as={NavLink}
                        onClick={() => setExpanded(false)}
                        to="/BetListLive"
                        className={
                          current_url === "BetListLive" ? "active1" : ""
                        }
                      >
                        BetListLive
                      </Nav.Link>
                      <Nav.Link
                        as={NavLink}
                        to="/RiskManagement"
                        onClick={() => setExpanded(false)}
                        className={
                          current_url === "RiskManagement" ? "active1" : ""
                        }
                      >
                        Risk Management
                      </Nav.Link>
                      {(user?.userType == "sub_owner" ||
                        user?.userType == "owner") && (
                          <NavDropdown
                            title="Banking Management"
                            id="basic-nav-dropdown"
                          >
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/banks"
                            >
                              {" "}
                              Banks
                            </NavDropdown.Item>
                          </NavDropdown>
                        )}
                      <NavDropdown title="Commission" id="basic-nav-dropdown">
                        {(user?.userType == "owner" ||
                          user?.userType == "sub_owner") && (
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/Withdraw_request"
                            >
                              {" "}
                              Withdraw Request
                            </NavDropdown.Item>
                          )}
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/commission-report"
                        >
                          {" "}
                          Commission Report
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/affiliate-kyc-list"
                        >
                          {" "}
                          Affiliate KYC List
                        </NavDropdown.Item>
                        {user?.userType == "agent" ||
                          user?.userType == "super_agent" ? (
                          <NavDropdown.Item
                            onClick={() => setExpanded(false)}
                            as={NavLink}
                            to="/affiliate-kyc"
                          >
                            {" "}
                            Affiliate KYC
                          </NavDropdown.Item>
                        ) : (
                          ""
                        )}
                        {(user?.userType == "owner" ||
                          user?.userType == "sub_owner") && (
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/agent-withdraw-history"
                            >
                              {" "}
                              Agent Withdraw History
                            </NavDropdown.Item>
                          )}
                        {user?.userType == "owner" ||
                          user?.userType == "sub_owner" ||
                          (user?.userType == "super_admin" && (
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/Commission_setting"
                            >
                              {" "}
                              Commission Setting
                            </NavDropdown.Item>
                          ))}
                      </NavDropdown>
                      {(user?.userType == "sub_owner" ||
                        user?.userType == "owner") && (
                          <NavDropdown
                            title="Wallet Management"
                            id="basic-nav-dropdown"
                          >
                            <NavDropdown.Item
                            onClick={() => setExpanded(false)}
                            as={NavLink}
                            to="/pending-deposit"
                          >
                            {" "}
                            Pending Deposit
                          </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/wallet-deposit"
                            >
                              {" "}
                              Wallet Deposit
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/wallet-withdrawal"
                            >
                              {" "}
                              Wallet Withdrawal
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/deposit-history"
                            >
                              {" "}
                              Deposit History
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/withdrawal-history"
                            >
                              {" "}
                              Withdrawal History
                            </NavDropdown.Item>
                          </NavDropdown>
                        )}
                      {(user?.userType == "sub_owner" ||
                        user?.userType == "owner") && (
                          <NavDropdown title="SMS" id="basic-nav-dropdown">
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/sms"
                            >
                             
                              Bkash SMS
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/nagad-sms"
                            >
                             
                              Nagad SMS
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/rocket-sms"
                            >
                              
                              Rocket SMS
                            </NavDropdown.Item>
                          </NavDropdown>
                        )}
                      <NavDropdown title="Others" id="basic-nav-dropdown">
                        
                        {(user?.userType == "owner" ||
                          user?.userType == "sub_owner") && (
                            <>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/offer"
                            >Offer
                            </NavDropdown.Item><NavDropdown.Item

                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/banner-list"
                            >Banner
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/result"
                            >Result
                            </NavDropdown.Item>
                            <NavDropdown.Item
                              onClick={() => setExpanded(false)}
                              as={NavLink}
                              to="/block-market"
                            >Block Market
                            </NavDropdown.Item>
                            </>
                          )}
                        {user?.userType == "owner" && (
                          <NavDropdown.Item
                            onClick={() => setExpanded(false)}
                            as={NavLink}
                            to="/sport-setting"
                          >Sport Setting
                          </NavDropdown.Item>
                        )}
                        <NavDropdown.Item
                          onClick={() => setExpanded(false)}
                          as={NavLink}
                          to="/general-setting"
                        >Admin Setting
                        </NavDropdown.Item>
                        
                      </NavDropdown>
                    </>
                  ) : (
                    <>
                    <Nav.Link
                      as={NavLink}
                      onClick={() => setExpanded(false)}
                      to="/commission-report"
                      className={
                        current_url === "commission-report" ? "active1" : ""
                      }
                    >
                      Commission Report
                    </Nav.Link>
                     <Nav.Link
                            onClick={() => setExpanded(false)}
                            as={NavLink}
                            to="/affiliate-kyc"
                            className={
                        current_url === "affiliate-kyc" ? "active1" : ""
                      }
                          >
                            {" "}
                            Affiliate KYC
                          </Nav.Link></>
                    
                  )}
                </Nav>
              </Navbar.Collapse>
              {/* <div className="main-header-time-zone">
                <ul className="list-unstyled  mb-0">
                  <li>
                    Time Zone : <span>GMT+5:30</span>
                  </li>
                  <li>
                    {isEmpty(user) ? (
                      <Link to="/login">
                        Login <i className="fa-solid fa-right-from-bracket"></i>
                      </Link>
                    ) : (
                      <a
                        style={{ cursor: "pointer" }}
                        as={NavLink}
                        to="#"
                        onClick={logoutUser}
                      >
                        Logout{" "}
                        <i className="fa-solid fa-right-from-bracket"></i>
                      </a>
                    )}
                  </li>
                </ul>
              </div> */}
            </Navbar>
          </Container>
        </div>
      </header>

      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Change Your Theme</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="text-center">
                <Form.Label for="primary" className="form-label">
                  Primary Color
                </Form.Label>
                <Form.Control
                  type="color"
                  className="form-control-color m-auto"
                  id="primary"
                  value="#3db39e"
                  title="Choose your color"
                  {...register("primary_color", {
                    required: "Please select color",
                  })}
                />
              </div>

              <div className="text-center">
                <Form.Label for="secondary" className="form-label">
                  Secondary Color
                </Form.Label>
                <Form.Control
                  type="color"
                  className="form-control-color m-auto"
                  id="secondary"
                  value="#060316"
                  title="Choose your color"
                  {...register("secondary_color", {
                    required: "Please select color",
                  })}
                />
              </div>
            </div>
            <button className="btn" type="submit">
              Save
            </button>
            <button className="btn" type="button">
              Reset
            </button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Header;
